import React from "react";
import { Container } from "react-bootstrap";

const PaymentMethods = () => {
  return (
    <Container className="text-center my-5 py-5">
      <h1>Payment method is comming soon!!</h1>
    </Container>
  );
};

export default PaymentMethods;
